// extracted by mini-css-extract-plugin
export var alignedimageandtext = "ParagraphAlignedImageAndText-module--alignedimageandtext--caa65";
export var imagecontainerleft = "ParagraphAlignedImageAndText-module--imagecontainerleft--f85ab";
export var imagecontainerright = "ParagraphAlignedImageAndText-module--imagecontainerright--30eff";
export var textleft = "ParagraphAlignedImageAndText-module--textleft--22380";
export var textright = "ParagraphAlignedImageAndText-module--textright--8deeb";